<app-dialog-heading [heading]="data.heading"></app-dialog-heading>

  <mat-grid-list [cols] = "columnNumber" rowHeight="54px" style="overflow-y: auto">
      <mat-grid-tile style="overflow-y: auto" *ngFor="let tile of tiles">
          {{tile}}
      </mat-grid-tile>
  </mat-grid-list>

<mat-dialog-actions align="center" class="dialog-button-container">
    <button class="dialog-button" mat-raised-button (click)="onSaveClick()" color="primary">Okay</button>
</mat-dialog-actions>
